import React from "react";
import Quote from "./Quote";

// Previously gated by a hard-coded password in this file. Access is now
// controlled by the server-side admin session (PrivateRoute in App.js).
// Renders the same quote as before (PBP).
export default function FluffySideClubQuote() {
  return (
    <div className="min-h-screen bg-white">
      <Quote slug="pbp" />
    </div>
  );
}
